import { updatesData } from '@/mocks/homeData';

const tagStyles: Record<string, string> = {
  '最新': 'bg-primary-100 text-primary-700',
  '热门': 'bg-accent-100 text-accent-700',
  '热议': 'bg-primary-100 text-primary-700',
  '绯闻': 'bg-accent-100 text-accent-700',
  '独家': 'bg-secondary-100 text-secondary-700',
  '事件': 'bg-secondary-100 text-secondary-700',
  '争议': 'bg-primary-100 text-primary-700',
};

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="mb-8 md:mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-2">
            最新快讯
          </h2>
          <p className="text-sm text-foreground-500">实时滚动更新，热点事件一网打尽</p>
        </div>

        <div className="max-w-3xl">
          <div className="relative pl-8 border-l-2 border-background-300 space-y-6">
            {updatesData.map((item) => (
              <div key={item.id} className="relative group cursor-pointer">
                <div className="absolute -left-[33px] top-1 w-3 h-3 rounded-full bg-accent-500 border-2 border-background-100" />
                <div className="bg-background-50 rounded-xl p-4 border border-background-200 group-hover:border-accent-200 transition-all">
                  <div className="flex items-center gap-3 mb-1.5">
                    <span className="text-xs text-foreground-400 font-mono whitespace-nowrap">{item.time}</span>
                    <span className={`px-1.5 py-0.5 rounded text-[10px] font-medium whitespace-nowrap ${tagStyles[item.tag] || 'bg-secondary-100 text-secondary-700'}`}>
                      {item.tag}
                    </span>
                  </div>
                  <h3 className="text-sm font-medium text-foreground-900 group-hover:text-primary-600 transition-colors">{item.title}</h3>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}